import React from 'react'
import styles from './viewProgressionMarker.module.sass'
import { ToastContainer } from 'react-toastify'
import { useSelector } from 'react-redux'
import ProgressionMarkerInfo from './ProgressionMarkerInfo'

const ViewProgressionMarker = ({isChanged, setIsChanged}) => {

  return (
    <>
      <ToastContainer />
      <div className={styles.row}>
        <div className={styles.col}>
          <ProgressionMarkerInfo  isChanged={isChanged} setIsChanged={setIsChanged} />
        </div>
      </div>
    </>
  )
}

export default ViewProgressionMarker